import {PagedRequestDto, PagedListingComponentBase} from '../../../../shared/paged-listing-component-base';
import { Component, OnInit, Injector } from '@angular/core';
import { UserDto, UserServiceProxy, PagedResultDtoOfUserDto } from '../../../../shared/service-proxies/service-proxies';
import { MatDialog } from '@angular/material';
import { finalize } from 'rxjs/operators';
import { UsersDataSource } from '../datasource/users-data-source';
import { BreakpointObserver } from '@angular/cdk/layout';


class PagedUsersRequestDto extends PagedRequestDto {
  keyword: string;
  isActive: boolean | null;
}


@Component({
  selector: 'kt-user-list',
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.scss']
})
export class UserListComponent extends PagedListingComponentBase<UserDto> implements OnInit {
  protected create(): void {
    throw new Error("Method not implemented.");
  }
  protected edit(id: any): void {
    throw new Error("Method not implemented.");
  }
 
 
  users: UserDto[] = [];
  keyword = '';
  isActive: boolean | null;
  
  dataSource : UsersDataSource;
  displayedColumns = ["id","userName", "fullName", "emailAddress", "roleNames","actions"];

  constructor(
    injector: Injector,
    private _userService: UserServiceProxy,
    private _breakPointObserver: BreakpointObserver,
    private _dialog: MatDialog
  ) {
      super(injector);

      _breakPointObserver.observe(['(max-width: 600px)']).subscribe(result => {
        this.displayedColumns = result.matches ? 
            ['id', 'fullName','actions'] : 
            ["id","userName", "fullName", "emailAddress", "roleNames","actions"];
      });
   }

  test() {
    abp.message.confirm(
      this.l('PAGE.MENU.DESC'),
      (result: boolean) => {
        true;
      }
    );
  }

  onRowClicked(row){
    console.log('Row Clicked', row);
  }

  ngOnInit(): void
  {
    this.dataSource = new UsersDataSource(this._userService);
    this.dataSource.loadUsers(1, "", "", 1, 1);
  }

  protected list(request: PagedRequestDto, pageNumber: number, finishedCallback: Function): void {
    throw new Error("Method not implemented.");
  }

  protected delete(user: UserDto): void {
    abp.message.confirm(
      this.l('UserDeleteWarningMessage', user.fullName),
      (result: boolean) => {
        if (result) {
          this._userService.delete(user.id).subscribe(() => {
            abp.notify.success(this.l('SuccessfullyDeleted'));
            this.refresh();
          });
        }
      }
    );
  }

 
}
